import React, { Component } from 'react'
import HttpServices from '../../../../utils/Http.services'
import CAMultiStage from '../../../CreateApplet/CAMultiStage'
import DiagramEditor from './DiagramEditor'
import { translate } from '../../../../utils/useful'
import store from '../../../../stores/storeConfig'
import { addNotif } from '../../../../stores/actionsList'
import AutomationAddNew from '../../../CreateApplet/AutomationAddNew'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../../stores/actionsList';
import { SessionData } from '../../../../variables/EntitiesData'


export class AutomationPage extends Component {
    state = {
        mode: '',
        data: {},
        components: {},
        paths: {},
        nodes: {},
        zoom: 1,
        showElements: true,
        variablesList: [],
        optionsList: {
            // { key: 'variables', label: 'variables' },
            // { key: 'calculator', label: 'calculatorTET' },
            // { key: 'function-name', label: 'Function Name' },
            // { key: 'function-test', label: 'Function test' },
        }
    }
    componentDidMount() {

        let windowData = this.props.windowData
        let baseUrl = this.props.baseUrl
        let params = windowData?.params
        let _id = windowData.path[baseUrl.length]

        if (_id != "new" && _id != null) {
            this.getFlows(_id)
        }

        if (_id == "new") {
            this.setState({ mode: 'new' })
        }

    }


    lastStage = () => {
        // console.log('here clicked')
        this.props.changePage('automations')

    }


    getFlows = (_id) => {


        if (_id && _id != "new") {
            let data = {}
            data._id = _id
            data.applet = this.props.variables.appletId
            HttpServices.request('getAutomation', data, (fetchResult, fetchError) => {
                if (fetchError || !fetchResult) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.getFailed', description: fetchError?.message })
                    return
                }
                try {

                    console.log(fetchResult)
                    let automation = fetchResult.automation
                    if (automation) {

                        let components = automation.flow?.components ?? {}
                        let paths = automation.flow?.paths ?? {}
                        let diagramVariables = automation?.diagramVariables ?? {}
                        let rawDynamicStructures = fetchResult?.rawDynamicStructures ?? {}
                        let rolesPermissions = fetchResult?.rolesPermissions
                        // console.log('rawDynamicStructures', rawDynamicStructures)

                        let optionsList = this.state.optionsList
                        optionsList.sharedVariables = { list: fetchResult.variables, sort: 1, dataType: 'object', label: '{{lang}}Shared variables', key: 'sharedVariables' }
                        let index = 2
                        // fetchResult.frames.forEach((element) => {
                        //     optionsList[element._id] = { list: element.fields, sort: index, label: element.name, key: element._id }
                        //     index += 1
                        // })

                        optionsList['diagramVariables'] = { list: [], sort: index, dataType: 'object', label: '{{lang}}Diagram variables', key: 'diagramVariables' }

                        optionsList.sessionVariables = { list: Object.values(SessionData), sort: 3, dataType: 'object', label: '{{lang}}Session variables', key: 'sessionVariables' }

                        // let frames = [{ id: 'collection', key: 'collection', name: this.props.page.name, pageType: 'collection' ,fields:[]}]
                        // let frames = this.props.frames
                        // console.log('this.props.pagepp', this.props.frames)
                        // console.log('fetchResult.variables', fetchResult.variables)
                        this.setState({ mode: automation.mode, diagramVariables, components, paths, flowName: automation.name, data: automation, rolesPermissions, variablesList: fetchResult.variables, optionsList, rawDynamicStructures }, () => {
                        })
                    }
                } catch (error) {
                    console.log('errr', error)
                }
            })
        }

    }



    updateAutomation = (flowName, stages) => {
        // this.setState({ isLoadingView: true })
        let data = {}
        data._id = this.state.data._id
        // data.collection = this.props.variables
        data.applet = this.props.applet._id
        data.name = flowName
        data.stages = stages

        console.log('data', data)
        // return
        HttpServices.request('postFlow', data, (fetchResult, fetchError) => {
            this.setState({ isLoadingView: false })
            if (fetchError) {
                store.dispatch(addNotif({ type: 'error', title: '{{lang}}errors.TypeRequired', description: translate("") }))
                return
            }
            store.dispatch(addNotif({ type: 'success', title: '{{lang}}info.savedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' }))

            // console.log('changgge', this.props.changePage)
            // if (this.props.changePage) {
            //     this.props.changePage('automations')
            // }
            // console.log('fetchhhherr', fetchError)

            // console.log('onsave')
        })

    }


    automationCreated = (automation) => {

        if (automation?._id) {
            let newLink = this.props.baseUrl.splice(2)
            newLink.push(automation?._id)
            this.props.changeWindowLink(newLink)
            setTimeout(() => {
                this.getFlows(automation?._id)
            }, 100);
        }
    }
    convertToAdvance = (data) => {
        // console.log('*convertToAdvance', this.state.data._id, this.props)
        let body = { _id: this.state.data._id, applet: (this.props.applet?._id ?? this.props.applet) }
        HttpServices.request('convertToAdvance', body, (fetchResult, fetchError) => {
            if (fetchError) {
                store.dispatch(addNotif({ type: 'error', title: '{{lang}}errors.TypeRequired', description: translate("") }))
                return
            }
            store.dispatch(addNotif({ type: 'success', title: '{{lang}}info.savedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' }))

            let automation = fetchResult.info
            if (automation) {

                let components = automation.flow?.components ?? {}
                let paths = automation.flow?.paths ?? {}
                let diagramVariables = automation.diagramVariables ?? {}

                let optionsList = this.state.optionsList
                optionsList.sharedVariables = { list: fetchResult.variables, sort: 1, label: '{{lang}}Shared variables', key: 'sharedVariables' }
                let index = 2
                fetchResult.frames.forEach((element) => {
                    optionsList[element._id] = { list: element.fields, sort: index, label: element.name, key: element._id }
                    index += 1
                })

                optionsList['diagramVariables'] = { list: [], sort: index, label: '{{lang}}Diagram variables', key: 'diagramVariables' }

                optionsList.sessionVariables = { list: Object.values(SessionData), sort: 3, label: '{{lang}}Session variables', key: 'sessionVariables' }

                // let frames = [{ id: 'collection', key: 'collection', name: this.props.page.name, pageType: 'collection' ,fields:[]}]
                // let frames = this.props.frames
                // console.log('this.props.pagepp', this.props.frames)
                // console.log('t1', automation.mode)
                this.setState({ mode: automation.mode, diagramVariables, components, paths, flowName: automation.name, data: automation, variablesList: fetchResult.variables, optionsList }, () => {
                })
            }


        })
    }


    render() {
        return (
            <div className='w-100 h-100'>

                {this.state.mode == 'new' && (
                    <div className='h-100 scroll-no-scrollbar'>
                        <AutomationAddNew hasHeaderName={true} customButtonAction={this.updateAutomation} automationCreated={this.automationCreated} flowName={this.state.flowName} customBackAction={this.lastStage} customHeader={'Stages'} customButtonTitle={'save'} frames={this.props.frames} page={this.props.page} language={this.props.language} baseUrl={this.props.baseUrl} setHeader={this.props.setHeader} colors={this.props.colors} windowData={this.props.windowData} data={this.props.data} automation={this.props.selectedAutomation} currentFrame={this.props.currentFrame} applet={this.props.applet} setData={this.props.setData} pages={this.props?.pages} width={this.props.width} height={this.props.height} variables={this.props.variables} user={this.props.user} modules={this.props.modules} changePage={this.props.changePage} title={"DiagramEditor"} description={"Manage things and applets"} route={this.props.route} functionsHandler={this.props.functionsHandler} selectedAutomation={this.props.selectedAutomation} headers={this.props.headers} changeMessengerStage={this.props.changeMessengerStage} initData={{ frames: this.props.frames, collectionInfo: { automations: this.state.data?.stages } }} />
                    </div>
                )}

                {this.state.mode == 'basic' && (
                    <div className='h-100 scroll-no-scrollbar'>
                        <CAMultiStage hasHeaderName={true} customButtonAction={this.updateAutomation} flowName={this.state.flowName} customBackAction={this.lastStage} customHeader={'Stages'} customButtonTitle={'save'} frames={this.props.frames} page={this.props.page} language={this.props.language} baseUrl={this.props.baseUrl} setHeader={this.props.setHeader} colors={this.props.colors} windowData={this.props.windowData} data={this.state.data} initRolesPermissions={this.state.rolesPermissions} automation={this.props.selectedAutomation} currentFrame={this.props.currentFrame} applet={this.props.applet} setData={this.props.setData} pages={this.props?.pages} width={this.props.width} height={this.props.height} variables={this.props.variables} user={this.props.user} modules={this.props.modules} changePage={this.props.changePage} title={"DiagramEditor"} description={"Manage things and applets"} route={this.props.route} functionsHandler={this.props.functionsHandler} selectedAutomation={this.props.selectedAutomation} headers={this.props.headers} changeMessengerStage={this.props.changeMessengerStage} initData={{ frames: this.props.frames, collectionInfo: { stages: this.state.data?.stages } }} convertToAdvance={this.convertToAdvance} />
                    </div>
                )}

                {(this.state.mode == 'advanced') && (
                    <>
                        <DiagramEditor frames={this.props.frames} page={this.props.page} flowName={this.state.flowName} language={this.props.language} baseUrl={this.props.baseUrl} setHeader={this.props.setHeader} colors={this.props.colors} windowData={this.props.windowData} data={this.state.data} automation={this.props.selectedAutomation} currentFrame={this.props.currentFrame} applet={this.props.applet} setData={this.props.setData} pages={this.props?.pages} width={this.props.width} height={this.props.height} variables={this.props.variables} user={this.props.user} modules={this.props.modules} changePage={this.props.changePage} title={"DiagramEditor"} description={"Manage things and applets"} route={this.props.route} functionsHandler={this.props.functionsHandler} selectedAutomation={this.props.selectedAutomation} headers={this.props.headers} changeMessengerStage={this.props.changeMessengerStage} components={this.state.components} initData={{ frames: this.props.frames, collectionInfo: { automations: this.state.data?.stages } }} paths={this.state.paths} diagramVariables={this.state.diagramVariables} variablesList={this.state.variablesList} optionsList={this.state.optionsList} rawDynamicStructures={this.state.rawDynamicStructures} />
                    </>
                )}
            </div>

        )
    }
}


const mapStateToProps = state => ({ settings: state.settings })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AutomationPage)
